export default {
  header: {
    collection: 'Collection',
    discord: 'Join Discord',
    twitter: 'Follow Twitter',
  },
  landing: {
    discover: 'Discover',
    nodeRocks: 'NODE_ROCKS',
    onBitcoin: 'on Bitcoin',
    searchPlaceholder: 'Enter Rock ID (1-10000)...',
    viewDetails: 'View Details',
  },
  errors: {
    dataLoad: 'Failed to load rock data. Please try again later.',
    rockNotFound: 'Rock not found. Please enter a number between 1 and 10000.',
    openFailed: 'Failed to open ordinal. Please try again.',
  },
  story: {
    title: 'The Story Behind NodeRocks',
    description: 'NodeRocks began in December, created by a developer known as {{developer}}. However, when the project faced a potential rug pull, the community refused to let it die. Instead, they rallied together, took control, and began rebuilding the project from the ground up.',
    community: 'The community quickly gained access to the {{platform}} developer portal and launched new social media channels to reconnect and grow. Within weeks, NodeRocks was stronger than ever, and the community started building exciting features like their own staking platform, explorer, and even creating music for the project.',
    conclusion: 'NodeRocks is now the first 100% community-driven project in the Ordinals space, a testament to the power of a passionate community coming together to push the project to new heights. From near collapse to a thriving, innovative community, NodeRocks has become a symbol of resilience and creativity in the world of Bitcoin Ordinals.',
  },
  yinYang: {
    title: 'Yin Yang Inscriptions',
    subtitle: 'Symbol of Harmony on Bitcoin forever on-chain',
    history: {
      title: 'History',
      description: 'Among the Cursed Inscriptions, a unique phenomenon emerged when {{positive}} and {{negative}} inscriptions were linked to the same satoshi. This pairing came to symbolize duality and harmony, drawing inspiration from the ancient Chinese philosophy of Yin and Yang.',
    },
    rarity: {
      title: 'How Rare are Yin Yang Inscriptions?',
      description: 'There are only {{count}} Yin Yang inscriptions forever on Bitcoin, making them an incredibly rare subset of the {{total}} total Cursed Inscriptions. Their creation ceased after the {{block}} in 2024, solidifying their rarity.',
    },
  },
  cursedRocks: {
    title: 'The Duality of Cursed Rocks',
    subtitle: 'A Unique Chapter in Bitcoin Ordinals',
    normal: 'Normal',
    cursed: 'Cursed',
    hoverReveal: 'Hover to reveal curse',
    whatAre: {
      title: 'Cursed Rocks?',
      description: 'Each NodeRock comes with its Cursed counterpart, as both are uniquely stored on the same satoshi. The NodeRock represents the positive inscription, while the Cursed Rock serves as its negative counterpart. Together, they form a perfect Yin Yang balance, symbolizing duality and interconnection.',
    },
    rarity: {
      title: 'Rarity & Value',
      description: 'NodeRocks is the first collection to offer a Buy 1, Get 2 concept, where each NodeRock comes with its paired Cursed Rock, forming a Yin Yang balance. With only 70,000 Yin Yang inscriptions ever created, there will never be new Yin Yang inscriptions—making each pair an exclusive and rare asset.',
    },
  },
  laboratory: {
    title: 'STAKE YOUR NODEROCKS!',
    stakeNow: 'STAKE NOW',
  },
  showcase: {
    title: 'Showcase Your Rock',
    subtitle: 'Join the digital art revolution on Bitcoin',
    viewCollection: 'View Full Collection',
  },
  footer: {
    language: 'Language',
    selectLanguage: 'Select Language',
    links: 'Quick Links',
    marketplace: 'Magic Eden Marketplace',
    discord: 'Join Discord',
    twitter: 'Follow Twitter',
    community: 'Community',
    rights: 'All rights reserved.',
  },
};